import React from "react";
import { CircularProgress, ThemeProvider } from "@mui/material";
import { observer } from "mobx-react-lite";

import "./LoadingSpinner.scss";
import { logoEsicBackground } from "../svg/svgImageList";
import Svg from "../svg/Svg";
import useTheme, { MUIComponentsTheme } from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";

interface ISpinner {
  width?: number;
  fullPage?: boolean;
  spinnerOnly?: boolean;
  overlay?: boolean;
}

export default observer(function LoadingSpinner(props: ISpinner) {
  const { theme, themeClass } = useTheme();
  const { width = 100, fullPage = false, spinnerOnly = false, overlay = false } = props;

  const loading = (
    <ThemeProvider theme={MUIComponentsTheme}>
      <div className="loading-spinner">
        <div className={themeClass(["spinner"])}>
          <CircularProgress />
          {!spinnerOnly && (
            <div>
              <Svg svg={logoEsicBackground[theme]} width={width} height={"100%"} />
              <span className="loading-text">{translationService.loadingText}</span>
            </div>
          )}
        </div>
      </div>
    </ThemeProvider>
  );

  if (fullPage) {
    return loading;
  }

  return <div className={overlay ? "loading-embedded overlay" : "loading-embedded"}>{loading}</div>;
});
